var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activityListPage"},[_c('common-header'),_vm._v(" "),_c('list-kv',{attrs:{"kvArray":_vm.kvItems}}),_vm._v(" "),_c('activityList',{attrs:{"tagArr":_vm.tagArr}}),_vm._v(" "),_c('common-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc2aa478","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/container/activityPage/activityList.vue
// module id = null
// module chunks = 